import { useEffect, useState } from 'react';
// import NextLink from 'next/link';
// import { useRouter } from 'next/router';
import { useLocation } from 'react-router-dom'
import PropTypes from 'prop-types';
import { Box, Divider, Drawer, Menu, MenuItem, Typography, useMediaQuery } from '@mui/material';
import { Selector as SelectorIcon } from '../icons/selector';
import {Logo} from './logo';
// import Logo from './LbrzLogo3.svg';
// import lbrzlogo from './lbrzlogo.png';
import { NavItem } from './nav-item';
import { useAuth } from '../contexts/AuthContext';
import { Icon } from '@iconify/react';

const items = [
  {
    href: '/orders',
    icon: ( <Icon icon="eva:shopping-bag-fill" />),
    // icon: ( <Icon icon="eva:shopping-cart-fill" />),
    title: 'Livraisons'
  },
  {
    href: '/items',
    icon: ( <Icon icon="eva:cube-fill" />),
    title: 'Produits en stock'
  },
  {
    href: '/locations',
    icon: ( <Icon icon="eva:home-fill" />),
    title: 'Boutiques'
  },
  // {
  //   href: '/notifications',
  //   icon: ( <Icon icon="eva:message-square-fill" />),
  //   title: 'Notifications'
  // },
  {
    href: '/rates',
    icon: ( <Icon icon="eva:grid-fill" />),
    title: 'Tarifs Livraison'
  },
  {
    href: '/help',
    icon: ( <Icon icon="eva:question-mark-circle-fill" />),
    title: 'Aide'
  }
];

export const DashboardSidebar = (props) => {
  const { open, onClose } = props;
  // const router = useRouter();
  const location = useLocation()

  const {retailers, retailerSelected, retailerName} = useAuth();

  const disabled = retailers.length == 0;

  const [anchorEl, setAnchorEl] = useState(null);
  const menuOpen = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {    
    setAnchorEl(null);
  };

  const handleSelection = (retailer) => {
    console.log(retailer);
    if(retailer) {
      console.log("change selection");      
      retailerSelected(retailer);
    }
    handleClose();
  }

  // console.log("SB retailer id " + retailerId);
  // console.log("SB retailer name " + retailerName);

  const lgUp = useMediaQuery((theme) => theme.breakpoints.up('lg'), {
    defaultMatches: true,
    noSsr: false
  });

  useEffect(
    () => {
      if (!location.pathname) {
        return;
      }

      if (open) {
        onClose?.();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [location.pathname]
  );

  const content = (
    <>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%'
        }}
      >
        <div>
          <Box sx={{ p: 3 }}>
            <Logo
              sx={{
                height: 42,
                width: 42
              }}
            />
          </Box>
          <Box sx={{ px: 2 }}>
            <Box
              sx={{
                alignItems: 'center',
                backgroundColor: 'rgba(255, 255, 255, 0.04)',
                cursor: disabled ? 'inherit' : 'pointer',
                display: 'flex',
                justifyContent: 'space-between',
                px: 3,
                py: '11px',
                borderRadius: 1,
              }}
              onClick={disabled ? null : handleClick}
              disabled={disabled}
            >
              <div>
                <Typography
                  color={disabled ? "neutral.500" : "inherit"}
                  variant="subtitle1"
                >
                  Enseigne
                </Typography>
                <Typography
                  color="neutral.400"
                  variant="body2"
                >
                  {retailerName}
                </Typography>
              </div>
              <SelectorIcon
                sx={{
                  color: 'neutral.500',
                  width: 14,
                  height: 14
                }}
              />
            </Box>
          </Box>
          <Menu
            id="basic-menu"
            anchorEl={anchorEl}
            open={menuOpen}
            onClose={handleClose}
          >
            {retailers.map((item) => (
              <MenuItem 
                key={item.id}
                onClick={() => handleSelection(item)}
                disabled={disabled}
              >
                {item.name}
              </MenuItem>
            ))}
          </Menu>
        </div>
        <Divider
          sx={{
            borderColor: '#2D3748',
            my: 3
          }}
        />
        <Box sx={{ flexGrow: 1 }}>
          {items.map((item) => (
            <NavItem
              key={item.title}
              icon={item.icon}
              href={item.href}
              title={item.title}
              disabled={retailers.length==0}              
            />
          ))}
        </Box>
        <Divider sx={{ borderColor: '#2D3748' }} />
        <Box
          sx={{
            px: 2,
            py: 3
          }}
        >
          <Typography
            color="neutral.100"
            variant="subtitle2"
          >
            Besoin d'aide ?
          </Typography>
          <Typography
            color="neutral.500"
            variant="body2"
          >
            N'hésitez pas à nous contacter.
          </Typography>
          <Typography
            color="neutral.500"
            variant="body2"
          >
            {/* Téléphone : +33 6 07 01 10 14 */}
            Tél : +33 6 99 52 46 37 
          </Typography>
          <Typography
            color="neutral.500"
            variant="body2"
          >
            {"(Lundi-Vendredi 9h-17h)"} 
          </Typography>
          <Typography
            color="neutral.500"
            variant="body2"
          >
            Email : support@loberz.com
          </Typography>
        </Box>
      </Box>
    </>
  );

  if (lgUp) {
    return (
      <Drawer
        anchor="left"
        open
        PaperProps={{
          sx: {
            backgroundColor: 'neutral.900',
            color: '#FFFFFF',
            width: 220
          }
        }}
        variant="permanent"
      >
        {content}
      </Drawer>
    );
  }

  return (
    <Drawer
      anchor="left"
      onClose={onClose}
      open={open}
      PaperProps={{
        sx: {
          backgroundColor: 'neutral.900',
          color: '#FFFFFF',
          width: 220
        }
      }}
      sx={{ zIndex: (theme) => theme.zIndex.appBar + 100 }}
      variant="temporary"
    >
      {content}
    </Drawer>
  );
};

DashboardSidebar.propTypes = {
  onClose: PropTypes.func,
  open: PropTypes.bool
};
